/* eslint-disable react/prop-types */
import React from 'react';
import { SYSTEM_ICON_SIZES } from '@fiverr-private/visuals/dist/esm/src/components/constants';
import { theme } from '@fiverr-private/theme';
import { Image } from '@fiverr-private/media';
import { BASE_CLOUDINARY_URL, CLOUDINARY_VISUALS_PATH } from '../../../../constants';

const SystemIcon = ({ iconName = 'HeartIcon', size, color }) => (
    <Image
        alt={iconName}
        height={SYSTEM_ICON_SIZES[size]}
        width={SYSTEM_ICON_SIZES[size]}
        src={`${BASE_CLOUDINARY_URL}/c_scale,e_colorize,co_rgb:${theme.colors[color].substring(1)},f_png,w_${
            SYSTEM_ICON_SIZES[size]
        }/${CLOUDINARY_VISUALS_PATH}/system/${iconName.replace('Icon', '')}.svg`}
    />
);

export default SystemIcon;
